import type { CSSProperties, ReactNode } from "react";
import { tuple } from "../_util/type";

export const IconButtonSize = tuple("xs", "sm", "md", "lg");

export interface IconButtonProps {
  // 设置按钮大小
  size?: typeof IconButtonSize[number];
  // 圆形按钮
  circle?: boolean;
  // 幽灵属性，使按钮背景透明
  ghost?: boolean;
  // 设置按钮的图标组件
  icon: ReactNode;
  // 按钮失效状态
  disabled?: boolean;
  // 点击事件
  onClick?: React.MouseEventHandler<HTMLElement>;
  // IconButton 容器类名
  className?: string;
  // 样式
  style?: CSSProperties;
}
